import { render, staticRenderFns } from "./course_view.vue?vue&type=template&id=39188ef2&scoped=true&"
import script from "./course_view.vue?vue&type=script&lang=ts&"
export * from "./course_view.vue?vue&type=script&lang=ts&"
import style0 from "./course_view.vue?vue&type=style&index=0&id=39188ef2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39188ef2",
  null
  
)

export default component.exports